import { Injectable } from '@angular/core';
import $ from 'jquery/dist/jquery.min';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class BaseUtils {
    constructor(public messageService: MessageService, public translate: TranslateService) { }

    showDownloadStartMessage() {
        this.toasterMessageAction('success', 'COMMON.EXPORT_STARTED', `${this.translate.instant('COMMON.EXPORT_STARTED_SUMMARY')}`);
    }

    showDownloadEndMessage() {
        this.toasterMessageAction('success', 'COMMON.EXPORT_FINISHED', `${this.translate.instant('COMMON.EXPORT_FINISHED')}`);
    }

    // function for manipulating loader on api call hit
    loading_spinner(val: any) {
        if (val) {
            $('.spinner_loader').css('display', 'block');
        } else {
            $('.spinner_loader').css('display', 'none');
        }
    }

    // global function for toaster function
    toasterMessageAction(type, summary, detail?, translateSummary = true, translateDetail = false) {
        if (summary) {
            switch (type) {
                case 'success':
                    this.messageService.add
                        ({
                            severity: 'success', summary: translateSummary ?
                                this.translate.instant(summary) : summary, detail: translateDetail ? this.translate.instant(detail) : detail
                        });
                    break;
                case 'error':
                    this.messageService.add
                        ({
                            severity: 'error', summary: translateSummary ?
                                this.translate.instant(summary) : summary, detail: translateDetail ? this.translate.instant(detail) : detail
                        });
                    break;
            }
        }
    }
}
